import * as React from "react";
import { Component } from "react";
import { Button, FormControl, FormGroup, Glyphicon } from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import { IBaseState } from "src/interfaces";
import { IServiceChargeRowProps } from "./interfaces";

export default class ServiceChargeLargeRow extends Component<IServiceChargeRowProps, IBaseState> {
  public constructor(props: IServiceChargeRowProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleDescriptionChanged = this.handleDescriptionChanged.bind(this);
    this.handleValueChanged = this.handleValueChanged.bind(this);
    this.handleUnitChanged = this.handleUnitChanged.bind(this);
    this.handleRateChanged = this.handleRateChanged.bind(this);
    this.deleteServiceCharge = this.deleteServiceCharge.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const { serviceCharge } = this.props;
    return (
      <tr key={serviceCharge.id}>
        <td id="input_cell">
          <FormGroup className="servicecharge-description2" bsSize="small" controlId="description">
            <FormControl
              className="servicecharge-description"
              bsSize="small"
              type="text"
              value={serviceCharge.description}
              onChange={this.handleDescriptionChanged}
            />
          </FormGroup>
        </td>
        <td>
          <FormGroup className="servicecharge-input2" bsSize="small" controlId="value">
            <CurrencyInput
              className="servicecharge-input form-control input-sm"
              id="servicecharge_value"
              inputType="text"
              value={serviceCharge.value}
              precision={2}
              allowNegative={true}
              selectAllOnFocus={true}
              onChangeEvent={this.handleValueChanged}
            />
          </FormGroup>
        </td>
        <td>
          <FormGroup controlId="unit">
            <select id="unit" value={serviceCharge.unit} onChange={this.handleUnitChanged}>
              <option value="kWh">kWh</option>
              <option value="K-OP">O-P</option>
              <option value="K-P">On-P</option>
              <option value="Days">Days</option>
              <option value="Cost">Cost</option>
              <option value="" />
            </select>
          </FormGroup>
        </td>
        <td>
          <FormGroup bsSize="small" controlId="serviceCharge_rate">
            <CurrencyInput
              className="servicecharge-input form-control input-sm"
              id="serviceCharge_rate"
              inputType="text"
              value={serviceCharge.rate}
              onChangeEvent={this.handleRateChanged}
              precision={6}
              allowNegative={true}
              selectAllOnFocus={true}
            />
          </FormGroup>
        </td>
        <td>
          <FormGroup bsSize="small" controlId="totalCharge">
            <CurrencyInput
              className="servicecharge-input form-control input-sm"
              id="servicecharge_totalCharge"
              inputType="text"
              value={serviceCharge.totalCharge}
              prefix={"$"}
              precision={2}
              allowNegative={true}
              tabIndex={-1}
              selectAllOnFocus={false}
            />
          </FormGroup>
        </td>
        <td>
          <Button
            bsSize="xsmall"
            bsStyle="danger"
            onClick={this.deleteServiceCharge}
            className="button-top-plus-half"
          >
            <Glyphicon glyph="glyphicon glyphicon-remove" />
          </Button>
        </td>
      </tr>
    );
  }

  private handleDescriptionChanged(e: any) {
    this.props.descriptionChanged(e.currentTarget.value, this.props.index);
  }
  private handleValueChanged(e: any) {
    this.props.valueChanged(e.target.value, this.props.index);
  }
  private handleUnitChanged(e: any) {
    this.props.unitChanged(e.target.value, this.props.index);
  }
  private handleRateChanged(e: any) {
    this.props.rateChanged(e.target.value, this.props.index);
  }
  private deleteServiceCharge(e: any) {
    e.preventDefault();
    this.props.deleteServiceCharge(this.props.serviceCharge);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/ServiceChargeLargeRow.tsx